import { createRequest, throwResErrors, createHeaders } from "./requestUtil";

export const getInfoStaticWidget = (config) => {
	return createRequest()
		.get(`/api/static-widgets/entries`, { params: config, headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};
